module.exports = {"TXTCLI_Required":{"id":"TXTCLI_Required","defaultMessage":"Szükséges","track":"Required"}}